export const PostReader = {
    init: function () {
      this.cacheSelectors();
      this.checkSpeechSynthesisSupport();
      this.bindEvents();
      this.isReading = false; // Inicializa o estado da leitura
      this.updateButtonVisibility(); // Garante a visibilidade inicial dos botões
    },
  
    cacheSelectors: function () {
      this.btnReadPlay = document.getElementById('btnReadPlay');
      this.btnReadPause = document.getElementById('btnReadPause');
      this.postContent = document.getElementById('postContent');
      this.synth = window.speechSynthesis;
  
      if (!this.btnReadPlay || !this.btnReadPause) {
        console.error('Botões não encontrados no DOM.');
      }
    },
  
    checkSpeechSynthesisSupport: function () {
      if (!this.synth) {
        console.error('Seu navegador não suporta a leitura de texto.');
      }
    },
  
    bindEvents: function () {
      if (this.btnReadPlay && this.btnReadPause) {
        this.btnReadPlay.addEventListener('click', this.startReading.bind(this));
        this.btnReadPause.addEventListener('click', this.stopReading.bind(this));
      }
    },
  
    startReading: function () {
      if (!this.synth) return;
  
      const textToRead = this.postContent.innerText || this.postContent.textContent;
  
      if (!textToRead.trim()) {
        console.error('Nenhum texto disponível para leitura.');
        return;
      }
  
      const utterance = new SpeechSynthesisUtterance(textToRead);
  
      utterance.lang = 'pt-BR';
      utterance.rate = 1;
      utterance.pitch = 1;
  
      utterance.onstart = () => {
        console.log('Leitura iniciada.');
        this.isReading = true;
        this.updateButtonVisibility();
      };
  
      utterance.onend = () => {
        console.log('Leitura finalizada.');
        this.isReading = false;
        this.updateButtonVisibility();
      };
  
      utterance.onerror = (event) => {
        console.error('Erro na leitura:', event.error);
        this.isReading = false;
        this.updateButtonVisibility();
      };
  
      this.synth.cancel();
      this.synth.speak(utterance);
    },
  
    stopReading: function () {
      this.synth.cancel();
      this.isReading = false;
      console.log('Leitura interrompida.');
      this.updateButtonVisibility();
    },
  
    updateButtonVisibility: function () {
      if (!this.btnReadPlay || !this.btnReadPause) {
        console.error('Botões não encontrados para atualizar visibilidade.');
        return;
      }
  
      if (this.isReading) {
        this.btnReadPlay.style.display = 'none';
        this.btnReadPause.style.display = 'inline-block';
      } else {
        this.btnReadPlay.style.display = 'inline-block';
        this.btnReadPause.style.display = 'none';
      }
    },
  };
  